<script setup>
import ChangeOfVolumeTag from "@/components/keyword/partials/ChangeOfVolumeTag.vue";

defineProps({
  text: {
    type: String,
    required: true,
  },
  tooltipText: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    required: true,
  },
  valueChange: {
    type: [Number, null],
    required: false,
    default: null,
  },
});

const numberFormat = (number) => {
  if (number) {
    return Number(number).toLocaleString();
  }

  return '0';
}
</script>

<template>
  <div class="tw-border-2 tw-border-grey-mid tw-rounded-lg tw-flex tw-flex-col tw-w-80 tw-h-44 tw-justify-center tw-text-center">
    <div class="tw-flex tw-items-center tw-justify-center tw-gap-3">
      <span class="tw-font-bold tw-text-4.5xl tw-text-blue">{{ numberFormat(value) }}</span>
      <ChangeOfVolumeTag
        v-if="valueChange !== null && valueChange !== undefined"
        :number="valueChange"
      />
    </div>

    <span class="tw-text-grey-dark tw-flex tw-justify-center tw-items-center">
      {{ text }}
      <svg-vue
        v-tooltip="{
          content: tooltipText,
          placement: 'bottom',
          theme: 'dark-blue-tooltip',
        }"
        icon="icons/question"
        class="tw-w-6 tw-h-7 tw-ml-2 tw-text-blue-mid tw-cursor-pointer"
      />
    </span>
  </div>
</template>
